import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageHero } from "./About";
import { SectionHeader } from "../components/UI";
import { ArrowRight, Handshake, Building2 } from "lucide-react";

export default function Partners() {
  const { t } = useTranslation();
  const profiles = t("members.profiles", { returnObjects: true });
  const openPositions = t("members.open_positions", { returnObjects: true });
  return (
    <div data-testid="page-partners">
      <PageHero eyebrow="Partners" title={t("partners_page.hero_title")} subtitle={t("partners_page.hero_subtitle")} image="https://images.pexels.com/photos/8463167/pexels-photo-8463167.jpeg"/>
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeader eyebrow="Founding" title={t("partners_page.founding")}/>
          <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {profiles.map((p, i) => (
              <div key={i} className="premium-card p-6 text-center" data-testid={`partner-founding-${i}`}>
                <div className="h-16 w-16 mx-auto rounded-sm bg-slate-100 flex items-center justify-center mb-4"><Building2 className="text-[#003399]" strokeWidth={1.5}/></div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-slate-400 font-display">{p.country}</div>
                <div className="mt-2 font-display font-semibold text-sm text-[#0B1120]">{p.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-24 md:py-32 bg-[#F5F7FB]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeader eyebrow="Expansion" title={t("partners_page.future")}/>
          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
            {openPositions.map((c, i) => (
              <div key={c} data-testid={`partner-future-${i}`} className="border-2 border-dashed border-slate-300 p-8 rounded-sm text-center hover:border-[#003399] transition-colors">
                <div className="text-[10px] tracking-[0.2em] uppercase text-slate-400 font-display">Open Position</div>
                <div className="mt-2 font-display font-semibold text-lg text-[#003399]">{c}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <Handshake className="mx-auto text-[#003399]" size={40} strokeWidth={1.5}/>
          <h2 className="mt-6 font-display font-semibold text-3xl md:text-4xl">{t("partners_page.become")}</h2>
          <Link to="/contact#partner" data-testid="partners-become-cta" className="btn-primary mt-8 inline-flex">{t("nav.partner_cta")} <ArrowRight size={16}/></Link>
        </div>
      </section>
    </div>
  );
}
